// extracted by mini-css-extract-plugin
export default {"container":"dcc_galleryModal-container","closeButton":"dcc_galleryModal-closeButton"};